import React from "react";
import { withRouter } from "react-router";

import { Button, Card, Input, Table, Tag, message } from "antd";

import { _getSupplierPriceLists } from "../../services";
import PriceListHeaderModal, { SellerSelect } from "./header-modal";
import { errorMessage } from "../term-contract/helpers";
import { formatDate } from "./helpers";

const MUTED = "rgba(0,0,0,0.45)";

/* an amber tag when there is something to look at, else a quiet count */
const attention = ({
    value,
}) => value ? <Tag color="orange">{value.toLocaleString()}</Tag> : <span style={{ color: MUTED }}>0</span>;

/** One row per supplier in this market, with what needs a look: unlinked lines, recent price changes, lines expiring soon. */
class PriceListList extends React.Component {

    state = { priceLists: [], total: 0, page: 1, pageSize: 50, sellerId: null, q: "", loading: false, creating: false };

    componentDidMount() {
        this.load();
    }

    load = async ({
        page = 1,
    } = {}) => {
        const { sellerId, q } = this.state;
        this.setState({ loading: true, page });
        try {
            const { data } = await _getSupplierPriceLists({ sellerId, q, page });
            this.setState({ priceLists: data.priceLists, total: data.total, pageSize: data.pageSize });
        } catch (e) {
            message.error(errorMessage({ error: e }));
        } finally {
            this.setState({ loading: false });
        }
    };

    open = ({
        priceList,
    }) => this.props.history.push(`/supplier/price-lists/${priceList._id}`);

    columns = [
        { title: "Supplier", dataIndex: "sellerName", render: name => <b>{name}</b> },
        { title: "Lines", dataIndex: "lineCount", align: "right", render: value => (value || 0).toLocaleString() },
        { title: "Unlinked", dataIndex: "unlinkedCount", align: "right", render: value => attention({ value }) },
        { title: "Price changed (30 days)", dataIndex: "priceChangedCount", align: "right", render: value => attention({ value }) },
        { title: "Expiring (60 days)", dataIndex: "expiringCount", align: "right", render: value => attention({ value }) },
        { title: "Last upload", dataIndex: "lastUploadAt", render: date => formatDate({ date }) }
    ];

    render() {
        const { priceLists, total, page, pageSize, sellerId, loading, creating } = this.state;
        return (
            <Card
                title="Supplier price lists"
                extra={<Button type="primary" icon="plus" onClick={() => this.setState({ creating: true })}>New price list</Button>}
            >
                <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 12 }}>
                    <SellerSelect
                        allowClear
                        placeholder="All suppliers"
                        style={{ width: 280 }}
                        value={sellerId}
                        onChange={value => this.setState({ sellerId: value }, this.load)}
                    />
                    <Input.Search
                        allowClear
                        placeholder="Search supplier name"
                        style={{ flex: 1, minWidth: 260 }}
                        onSearch={value => this.setState({ q: value.trim() }, this.load)}
                    />
                </div>
                <Table
                    rowKey="_id"
                    loading={loading}
                    dataSource={priceLists}
                    columns={this.columns}
                    pagination={{ current: page, pageSize, total, onChange: p => this.load({ page: p }) }}
                    onRow={priceList => ({ onClick: () => this.open({ priceList }), style: { cursor: "pointer" } })}
                />
                {creating && (
                    <PriceListHeaderModal
                        onCancel={() => this.setState({ creating: false })}
                        onSaved={priceList => this.open({ priceList })}
                        onExisting={priceList => this.open({ priceList })}
                    />
                )}
            </Card>
        );
    }
}

export default withRouter(PriceListList);



// WEBPACK FOOTER //
// ./src/components/supplier-price-list/index.js